import { OutsideEnrollmentAreaStatus } from "./OutsideEnrollmentAreaStatus";
import { RequestStatus } from "./RequestStatus";
import { RequestType } from "./RequestType";
import { Address } from "../Shared/Address";

/**
 * This entity combines finished Request and Draft metadata.
 * The id is positive for finished Requests and negative for
 * Draft requests.
 */
export interface RequestMetadata {
  id: number;
  institutionId?: number;
  code?: string;
  schoolYearId: number;
  childOib?: string;
  parentOib?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: Date;
  permanentAddress?: Address;
  temporaryAddress?: Address;
  status: RequestStatus;
  requestType: RequestType;
  isAdminCreated: boolean;

  //isOutsideEnrollmentArea: boolean;
  schoolCandidateId?: number;
  //schoolCandidateAddReasonId?: number;
  //schoolCandidateCancelReasonId?: number;
  //schoolCandidateStatusId?: number;
  //schoolCandidateUOGUCountyId?: number;

  //outsideEnrollmentAreaStatus?: OutsideEnrollmentAreaStatus;
  institutionName?: string;
  //outsideEnrollmentAreaInstitutionName?: string;

  isHandicapped: boolean;
}

export enum RequestSort {
  Code = 1,
  LastName,
  Birthday,
  Address,
  Type,
  Status,
}
